<template>
    <b-modal
        v-model="modalShow"
        class="ext-modal ext-modal--xl"
        hide-header
        :ok-only="true"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div>
            <div class="d-flex align-items-center mb-2">
                <img :src="url" class="u-fit">
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ImageModal',

    data: function () {
        return {
            modalShow: false,
            url: null,
        }
    },

    created: function () {
        bus.$on('open-modal-image', this.open)
    },

    beforeDestroy: function () {
        this.url = null
        bus.$off('open-modal-image')
    },

    methods: {
        open: function (url) {
            this.url = url
            this.modalShow = true
        },

        close: function () {
            this.url = null
            this.modalShow = false
        },
    },
}
</script>

<style scoped lang="scss">
.alert {
    position: fixed;
    left: 50%;
    top: 20px;
    z-index: 9999;
    width: 80vw;
    transform: translate(-50%, 0);
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

#edit_birth_year {
    min-width: 70px;
}

#edit_birth_month {
    min-width: 45px;
}

#edit_birth_day {
    min-width: 45px;
}

.icon-pencil {
    position: relative;
    top: 2px;
    width: 14px;
    margin-left: 3px;
    cursor: pointer;
}
</style>
